export { VideoPlayerWithTabs } from './VideoPlayerWithTabs';
export type { VideoPlayerWithTabsProps } from './VideoPlayerWithTabs';
